export enum SiblingRelationship {
  HalfSibling = 1,
  Natural = 2,
  Step = 3,
}
